<template>
  <section class="o-section o-section--full">
    <div class="o-section__wrapper">
      <div class="o-wrapper">

        <div class="u-align-center o-flex u-padding-bottom c-header-spacing">
          <div>
            <div class="c-logo">
              <img :src="`/assets/logo_${lang}.${extension}`" :alt="`Logo ${globals.title}`">
            </div>

            <div class="u-margin-top">
              <SocialShare />
            </div>
          </div>

          <div class="u-margin-top u-6/12@desktop u-push-3/12@desktop">
            <p v-html="translations.text"></p>
          </div>

          <div class="u-margin-top u-6/12@desktop u-push-3/12@desktop">
              <div v-show="isDesktop" class="u-margin-top">
                <div class="u-h2">
                  <a :href="`/assets/presskit_${lang}.zip`" target="_blank" class="e-link--underline">{{ translations.download }}</a> {{ translations.presskit }}
                </div>
              </div>
          </div>
        </div>

      </div>

      <div class="o-section__figure-wrapper is-bottom-left">
        <figure class="o-section__figure" ref="figureA">
          <Img :src="require('@/assets/outro/outro_a.png')" filename="outro_a" />
        </figure>

        <figure class="o-section__figure" ref="figureB">
          <Img :src="require('@/assets/outro/outro_b.png')" filename="outro_b" />
        </figure>
      </div>

    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import SocialShare from '@/components/SocialShare'
import Img from '@/components/Img'

export default {
  name: 'Outro',
  props: ['options', 'active', 'isDesktop', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene14', () => {
      this.init()
    })
  },

  methods: {
    init () {
      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureB,
          translateY: ['-20px', '0'],
          opacity: [0, 1],
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureB,
          translateY: ['-20px', '0'],
          filter: ['blur(15px)', 'blur(0px)'],
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      }

      this.$anime({
        targets: this.$refs.figureA,
        translateY: ['30px', '0'],
        translateX: ['-20px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })
    }
  },

  computed: mapState({
    lang: state => state.language,
    webP: state => state.webp,
    translations (state) {
      const lang = this.lang
      return state.translations.outro[lang]
    },
    globals (state) {
      const lang = this.lang
      return state.translations.general[lang]
    },
    extension () {
      return this.webP ? 'webp' : 'png'
    }
  }),

  components: {
    SocialShare,
    Img
  }
}
</script>
